const QUANTITY_PATTERN = /^(\d+[\d/.]*\s*(?:cups?|tbsp|tablespoons?|tsp|teaspoons?|oz|ounces?|lbs?|pounds?|g|grams?|kg|kilograms?|ml|milliliters?|l|liters?|pinch(?:es)?|dash|clove[s]?|slices?|pieces?|bunch(?:es)?|heads?|stalks?|cans?|bottles?|bags?|boxes?|handful|large|medium|small)?\.?\s*)/i;
const PREP_PATTERN = /(?:,\s*)?(?:sifted|chopped|minced|diced|sliced|grated|crushed|ground|peeled|diced|julienned|pureed|mashed|roasted|toasted|blanched|cooked|steamed|boiled|fried|baked|fresh|dried|canned|frozen|deveined|shelled|boneless|skinless|fine|coarse)(?:\s+(?:into\s+\w+)?)?$/i;
const SUB_INGREDIENT_PATTERN = /\(([^)]+)\)/;
export function parseIngredients(rawText) {
    if (!rawText || rawText.trim().length === 0) {
        return { tokens: [], error: null };
    }
    // First, protect parenthetical groups from comma splitting
    const protectedText = rawText.replace(/\(([^)]+)\)/g, (match) => {
        return match.replace(/,/g, '\x00'); // Replace commas inside parens with null char
    });
    const tokens = [];
    const fragments = protectedText.split(/[,\n]+|\.\s+(?=[A-Z])/);
    let currentOffset = 0;
    for (const fragment of fragments) {
        const trimmed = fragment.replace(/\x00/g, ',').trim();
        if (trimmed.length === 0) {
            currentOffset += fragment.length + 1; // +1 for delimiter
            continue;
        }
        const startIndex = rawText.indexOf(trimmed, currentOffset);
        const endIndex = startIndex + trimmed.length;
        currentOffset = endIndex + 1;
        // Extract quantity
        let remaining = trimmed;
        let quantity = null;
        const qtyMatch = remaining.match(QUANTITY_PATTERN);
        if (qtyMatch?.[0]) {
            quantity = qtyMatch[0].trim();
            remaining = remaining.slice(qtyMatch[0].length).trim();
        }
        // Extract preparation method
        let preparation = null;
        const prepMatch = remaining.match(PREP_PATTERN);
        if (prepMatch) {
            preparation = prepMatch[0].replace(/^,\s*/, '').trim();
            remaining = remaining.slice(0, remaining.length - prepMatch[0].length).trim();
        }
        // Check for compound ingredient (parenthetical sub-ingredients)
        const subMatch = remaining.match(SUB_INGREDIENT_PATTERN);
        const isCompound = subMatch !== null;
        // Normalize ingredient name
        const name = normalizeName(remaining);
        const id = `${tokens.length}-${name.slice(0, 20).replace(/\s+/g, '-')}`;
        tokens.push({
            id,
            rawText: trimmed,
            name,
            quantity,
            preparation,
            startIndex,
            endIndex,
            isCompound,
            subIngredientIds: [],
        });
    }
    return { tokens, error: null };
}
function normalizeName(raw) {
    let name = raw
        // Remove parenthetical sub-ingredients (we detect them via isCompound)
        .replace(/\([^)]+\)/, '')
        .trim()
        // Remove common non-ingredient prefixes
        .replace(/^(organic|fresh|dried|canned|frozen|fine|coarse)\s+/i, '')
        // Remove trailing punctuation
        .replace(/[.;:]+$/, '')
        // Strip leading/trailing connector words left over from comma splitting
        .replace(/^(and|or|with|of|the|a|an|in|for|also|including)\s+/gi, '')
        .replace(/\s+(and|or|with|of|the|a|an|in|for|also|including)$/gi, '')
        // Lowercase and trim
        .trim()
        .toLowerCase();
    return name;
}
//# sourceMappingURL=parseIngredients.js.map